<template>
  <a-responsive class="animated-icons__wrapper" :aspect-ratio="aspectRatio">
    <transition :name="transitionName" mode="out-in">
      <a-icon
        v-if="currentIcon"
        :key="currentIcon"
        :original="true"
        :icon="currentIcon"
        class="animated-icons__icon"
        width="auto"
        height="auto"
      />
    </transition>
  </a-responsive>
</template>

<script>
import AIcon from 'shared/AIcon/index.vue'
import { PROP_TYPES, propValidator } from '@/utils/validators'
import AResponsive from 'shared/AResponsive/index.vue'
import { hydrationHelpers } from '@/utils/mixins/hydrationHelpers'

const INITIAL_DELAY = 500
const ROTATION_PERIOD = 3500

const TRANSITION_NAME = {
  FADE: 'fade',
  DROP: 'drop'
}

export default {
  name: 'HomepageTopSectionAnimatedIcons',
  mixins: [hydrationHelpers],
  components: { AResponsive, AIcon },
  props: {
    icons: propValidator([PROP_TYPES.ARRAY]),
    aspectRatio: propValidator([PROP_TYPES.STRING, PROP_TYPES.NUMBER])
  },
  data() {
    return {
      currentIconIndex: 0,
      currentIcon: null
    }
  },
  computed: {
    transitionName() {
      return this.$_hydrationHelpers_isLayoutMobile
        ? TRANSITION_NAME.FADE
        : TRANSITION_NAME.DROP
    }
  },
  methods: {
    rotateIcons() {
      if (this.currentIcon === null) {
        // This is for the very first icon display
        this.currentIcon = this.icons[this.currentIconIndex]
      }

      setInterval(() => {
        this.currentIconIndex = (this.currentIconIndex + 1) % this.icons.length
        this.currentIcon = this.icons[this.currentIconIndex]
      }, ROTATION_PERIOD)
    }
  },
  async mounted() {
    // Use of nextTick to ensure the DOM has been updated before starting animation
    await this.$nextTick()

    setTimeout(() => {
      this.rotateIcons()
    }, INITIAL_DELAY)
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity ease-in-out 2s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.drop-enter-active,
.drop-leave-active {
  transition: opacity ease-in-out 2s, transform ease-in-out 1s;
}

.drop-enter {
  opacity: 0;

  $transform: (
    $above-desktop-xl: translateY(-30%),
    $desktop-sm: translateY(-20%),
    $tablet: translateY(-30%)
  );

  @include setStyleByBreakpoint('transform', $transform);
}

.drop-enter-to {
  transform: translateY(0);
  opacity: 1;
}

.drop-leave-to {
  opacity: 0;

  $transform: (
    $above-desktop-xl: translateY(30%),
    $desktop-sm: translateY(20%),
    $tablet: translateY(30%)
  );

  @include setStyleByBreakpoint('transform', $transform);
}

.animated-icons__icon {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
</style>
